// @ts-check
export const CTA_TOOLTIP_TEXTS = {
  BOOK_A_DEMO: 'Book a demo',
  MANAGE_TEAMS: 'Manage teams',
  ACTIVITY_SERVICES: 'Not available in Free tier',
  ACTIVITY_TEAMS: 'Not available in Free tier',
  ACTIVITY_CONTRIBUTORS: 'Not available in Free tier',
  ACTIVITY_AUTHORS: 'Not available in Free tier',
  METRICS_TEAMS: 'Upgrade LinearB to drill down into team views',
  METRICS_MEMBERS: 'UPGRADE LINEARB TO VIEW METRICS BY MEMBERS',
  METRICS_DASHBOARD_SELECTOR: 'Trial LinearB for full custom metrics',
  TOPBAR: 'Start a LinearB trial for access to complete historical data',
  TOPBAR_PAID: 'Select groups or teams to view different time frames',
  NOTIFICATIONS: "Get Real Time Notifications with one of LinearB's paid plans"
};

export const CTA_PAGE_TEXTS = {
  TEAM_GOALS_TEXT: 'STANDARDIZE GOALS AND REPORTING',
  TEAM_GOALS_BUTTON: 'SCHEDULE A CONSULTATION',
  METRICS_TEAMS_TEXT: 'UNLOCK TEAM METRICS',
  METRICS_TEAMS_BUTTON: 'SCHEDULE A CONSULTATION'
};

export const DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS = 90;

export const CUSTOM_COMPONENTS_PLACEHOLDERS = {
  ALL_AUTHOR: 'All authors',
  ALL_TEAMS: 'All teams',
  ALL_CONTRIBUTORS: 'All contributors',
  ALL_SERVICES: 'All services'
};

export const CALL_TO_ACTION_SLIDES_TEXTS = /** @type {const} */ ({
  GET_STARTED: 'Get Started',
  CARD_HEADER_GOALS: 'Goals and Reporting',
  CARD_TEXT_GOALS: 'Set engineering standards and get alerts for at-risk work',
  CARD_HEADER_RESOURCE_ALLOCATION: 'Resource Allocation',
  CARD_TEXT_RESOURCE_ALLOCATION:
    'Align engineering investments to business outcomes',
  CARD_HEADER_PROJECT_DELIVERY: 'Predictable Project Delivery',
  CARD_TEXT_PROJECT_DELIVERY: 'Accurately forecast software delivery milestones'
});

export const NO_PM_TOOL_TEXTS = /** @type {const} */ ({
  CONNECT_PM_TOOL_BUTTON: 'Finish Setup',
  LEFT_COLUMN_TITLE: 'MTTR',
  RIGHT_COLUMN_TITLE: 'CFR',
  CONNECT_PM_TOOL_DESCRIPTION:
    'Connect your project management provider to view your complete DORA metrics.'
});

export const TRACKING = {
  EVENTS: {
    CTA_CLICK: 'cta-clicked'
  },
  CTA_TYPE: {
    TOOLTIP: 'tooltip',
    CAROUSEL: 'carousel',
    FILTERS: 'filters',
    BUTTON: 'button',
    DROPDOWN: 'dropdown',
    LINK: 'link'
  },
  CTA_SLIDES: {
    GOALS_REPORTING: 'goals-and-reporting',
    RESOURCE_ALLOCATION: 'resource-allocation',
    PREDICTABLE_PAGE_DELIVERY: 'predictable-project-delivery'
  },
  CTA_INTENT: {
    BOOK_A_DEMO: 'book-a-demo',
    SETUP_PM: 'setup-pm',
    DASHBOARD_CAROUSEL: 'dashboard-carousel',
    EDUCATION: 'education',
    MANAGE_TEAMS: 'manage-teams'
  }
};
